import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/employee-profiles', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getByPositionHierarchies = orgChartStructureId => {
  return httpClient
    .get(`/api/employee-profiles/by-position-hierarchies/${orgChartStructureId}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/employee-profiles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, options = {}) => {
  return httpClient
    .get(`/api/employee-profiles/${id}`, options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/employee-profiles/${data.employee_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient.delete(`/api/employee-profiles/${id}`).then(response => Promise.resolve(response.data))
}

export const getPosition = (options = {}) => {
  return httpClient
    .get('/api/employee-profiles/logic-positions', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getStatus = (options = {}) => {
  return httpClient
    .get('/api/employee-profiles/status', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const photoUpload = data => {
  return httpClient
    .post('/api/employee-profiles/photos', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getShift = (Option = {}) => {
  return httpClient
    .get('/api/shift-managements?page=-1&fields[hris_shifts]=shift_id,shift_name,shift_type')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getPcDate = (Option = {}) => {
  return httpClient
    .get('/api/payroll-cycle-dates?page=-1&fields[pay_payroll_cycle_date]=pc_date_id,pc_date_name')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getPaymentType = (Option = {}) => {
  return httpClient
    .get('/api/employee-profiles/payment-types')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const printCard = data => {
  return httpClient
    .post('/api/employee-profiles/printing-card', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getNationality = (Option = {}) => {
  return httpClient
    .get('/api/nationalities?page=-1')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getByShift = shiftId => {
  return httpClient
    .get(`/api/employee-profiles/by-shifts/${shiftId}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  getByPositionHierarchies,
  store,
  find,
  update,
  destroy,
  photoUpload,
  getPosition,
  getStatus,
  getShift,
  getPcDate,
  getPaymentType,
  printCard,
  getNationality,
  getByShift
}
